const ANALYZE_BARCODE_SCAN = 'ANALYZE_BARCODE_SCAN';
const ANALYZE_BARCODE_ACTION_TRIGGER = 'ANALYZE_BARCODE_ACTION_TRIGGER';


export {
  ANALYZE_BARCODE_ACTION_TRIGGER,
  ANALYZE_BARCODE_SCAN,
};

